import { Component, computed, input } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
	selector: "app-typeform-offcanvas",
	templateUrl: "./typeform-offcanvas.component.html",
	styleUrls: ["./typeform-offcanvas.component.css"],
	standalone: false
})
export class TypeformOffcanvasComponent {
	formId = input("");

	readonly TYPEFORM_URL = "https://form.typeform.com/to/";

	isPanelOpen = false;
	typeformUrl = computed<SafeResourceUrl | undefined>(() => {
		const id = this.formId();
		if (!id) return undefined;
		const url = `${this.TYPEFORM_URL}${id}`;
		return this.sanitizer.bypassSecurityTrustResourceUrl(url);
	});

	constructor(private sanitizer: DomSanitizer) {}

	openPanel(): void {
		this.isPanelOpen = true;
	}

	closePanel(): void {
		this.isPanelOpen = false;
	}
}
